<div class="d-flex">
  <div class="nav-flex-column nav-pills me-3 tablist fw-bold" role="tablist">
    <button class="nav-link" [ngClass]="activeTab === 'condition' ? 'bg-primary text-white' : 'bg-info'" (click)="selectTab('condition')">
      {{ 'SELECT_BY_OPERATING_CONDITION' | translate }}
    </button>
    <button class="nav-link" [ngClass]="activeTab === 'model' ? 'bg-primary text-white' : 'bg-info'" (click)="selectTab('model')">
      {{ 'SELECT_BY_MODEL' | translate }}
    </button>
  </div>
</div>
<div class="form-container">
  @if (!isLoading && fields.length > 0 && activeTab === 'condition' && (fields | json) !== '{}') {
    <div class="dynamic-form-builder">
      <app-dynamic-form [formFields]="fields" [tab]="activeTab" (formValueChanged)="handleFormValueChanged($event)"></app-dynamic-form>
    </div>
  }
  @if (isLoading || !checkboxesLoaded) {
    <div class="spinner-placeholder d-flex justify-content-center align-items-center">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  }
  @if (!isLoading && !hasSelection && checkboxesLoaded) {
    <div class="d-flex flex-column justify-content-center align-items-center text-center p-5 w-100">
      <i class="fas fa-filter fa-2x text-muted mb-3"></i>
      <p class="text-muted fw-semibold mb-1">{{ 'PRODUCTS.SELECT_DRYER_TO_CONTINUE' | translate }}</p>
      <p class="text-muted small">{{ 'PRODUCTS.SELECT_DRYER_HINT' | translate }}</p>
    </div>
  }
  @if (!isLoading && fields.length > 0 && activeTab === 'model' && (fields | json) !== '{}') {
    <div class="dynamic-form-builder">
      <app-dynamic-form-model
        [formFields]="fields"
        [tab]="activeTab"
        [models]="models"
        (formValueChanged)="handleFormValueChanged($event)"
        (modelSelected)="onModelSelected($event)"></app-dynamic-form-model>
    </div>
  }
</div>
<div class="submit-button d-flex justify-content-end align-content-start">
  <button
    type="button"
    class="btn btn-primary p-2 trigger-submit"
    (click)="handleSubmit()"
    [disabled]="
      !allRequiredFieldsPresent ||
      (activeTab === 'model' &&
        !!fetchLatestFormValues?.formValues?.selectedModel &&
        !models.includes(fetchLatestFormValues?.formValues?.selectedModel))
    ">
    {{ 'SUBMIT' | translate }}
  </button>
</div>
@if (activeTab === 'condition') {
  <div>
    <app-dryer-filter-table
      [tab]="activeTab"
      [sensorValues]="transformData"
      (modelEmitter)="onDefaulModelName($event)"></app-dryer-filter-table>
  </div>
}
@if (activeTab === 'model') {
  <div>
    <app-dryer-filter-table [tab]="activeTab"></app-dryer-filter-table>
  </div>
}
